import React, { useState } from 'react';
import { Facebook } from 'lucide-react';
import { LegalModal, LegalModalKey } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<LegalModalKey>(null);
  const links: {
    key: Exclude<LegalModalKey, null>;
    label: string;
  }[] = [{
    key: 'privacy',
    label: 'Política de privacidad'
  }, {
    key: 'terms',
    label: 'Términos y condiciones'
  }, {
    key: 'refund',
    label: 'Política de reembolso'
  }, {
    key: 'contact',
    label: 'Contacto / soporte'
  }];
  return <>
      <footer className="w-full bg-cream px-4 py-12 border-t border-taupe/20" data-id="element-75">
        <div className="max-w-6xl mx-auto flex flex-col items-center text-center space-y-8" data-id="element-76">
          <div data-id="element-77">
            <h2 className="font-serif text-2xl tracking-widest uppercase text-ink mb-2" data-id="element-78">
              EpikkaStore
            </h2>
            <p className="text-taupe text-sm" data-id="element-79">
              Bienestar femenino integral. Guías digitales pensadas para ti.
            </p>
          </div>

          {/* Social */}
          <div className="flex flex-col items-center gap-3" data-id="element-80">
            <span className="text-xs font-bold tracking-widest text-taupe uppercase" data-id="element-81">
              Síguenos
            </span>
            <a href="https://www.facebook.com/profile.php?id=61572064552166" target="_blank" rel="noopener noreferrer" aria-label="Facebook de EpikkaStore" className="inline-flex items-center justify-center w-10 h-10 rounded-full text-clay hover:text-clay-dark hover:bg-clay/5 transition-colors" data-id="element-82">
              <Facebook className="w-6 h-6" strokeWidth={1.6} data-id="element-83" />
            </a>
          </div>

          {/* Legal links — open modals */}
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-ink/70 font-medium" data-id="element-84">
            {links.map(link => <button key={link.key} type="button" onClick={() => setActiveModal(link.key)} className="hover:text-clay transition-colors underline-offset-4 hover:underline focus:outline-none focus:text-clay" data-id="element-85">
                {link.label}
              </button>)}
          </div>

          <div className="pt-8 border-t border-taupe/10 w-full max-w-2xl text-xs text-ink/50 leading-relaxed" data-id="element-86">
            <p className="mb-2" data-id="element-87">
              © 2026 EpikkaStore. Todos los derechos reservados.
            </p>
            <p data-id="element-88">
              Apaga tu Inflamación es una guía educativa e informativa que no
              sustituye el consejo médico profesional.
            </p>
          </div>
        </div>
      </footer>

      <LegalModal activeKey={activeModal} onClose={() => setActiveModal(null)} data-id="element-89" />
    </>;
}